import { isPlatformBrowser } from '@angular/common';
import type { AfterViewInit, OnDestroy } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { WebSocketService } from '@freelancer/datastore';
import {
  ToastAlertColor,
  ToastAlertService,
  ToastAlertType,
} from '@freelancer/ui/toast-alert';
import type { Subscription, Observable } from 'rxjs';

@Component({
  selector: 'fl-network-alert',
  template: `
    <fl-toast-alert
      [id]="'fl-websocket-alert'"
      [timeout]="undefined"
      [closeable]="true"
      [color]="ToastAlertColor.DARK"
      [type]="ToastAlertType.ERROR"
    >
      {{ websocketDisconnectedMessage$ | flAsync }}
    </fl-toast-alert>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NetworkAlertComponent implements AfterViewInit, OnDestroy {
  ToastAlertType = ToastAlertType;
  ToastAlertColor = ToastAlertColor;

  private offlineSubscription?: Subscription;
  private websocketDisconnectedSubscription?: Subscription;

  websocketDisconnectedMessage$: Observable<string | undefined>;

  constructor(
    private websocket: WebSocketService,
    private toastAlertService: ToastAlertService,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {}

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.websocketDisconnectedMessage$ =
        this.websocket.getDisconnectedMessage();
      this.websocketDisconnectedSubscription =
        this.websocketDisconnectedMessage$.subscribe(message => {
          if (message) {
            this.toastAlertService.open('fl-websocket-alert');
          } else {
            this.toastAlertService.close('fl-websocket-alert');
          }
        });
    }
  }

  ngOnDestroy(): void {
    this.offlineSubscription?.unsubscribe();
    this.websocketDisconnectedSubscription?.unsubscribe();
  }
}
